import Vue from 'vue'
import Router from 'vue-router'
import AppLayout from '@/layout/AppLayout.vue'

Vue.use(Router)

const Dashboard = () => import('@/views/Dashboard.vue')
const OrderList = () => import('@/views/orders/OrderList.vue')
const OrderForm = () => import('@/views/orders/OrderForm.vue')
const OrderDetail = () => import('@/views/orders/OrderDetail.vue')
const AutoQuote = () => import('@/views/quotes/AutoQuote.vue')
const QuoteList = () => import('@/views/quotes/QuoteList.vue')
const QuoteDetail = () => import('@/views/quotes/QuoteDetail.vue')
const SampleList = () => import('@/views/samples/SampleList.vue')
const SampleDetail = () => import('@/views/samples/SampleDetail.vue')
const ProductionOverview = () => import('@/views/production/ProductionOverview.vue')
const ProductionDetail = () => import('@/views/production/ProductionDetail.vue')
const WorkshopPage = () => import('@/views/workshop/WorkshopPage.vue')
const QcPage = () => import('@/views/qc/QcPage.vue')
const InventoryPage = () => import('@/views/inventory/InventoryPage.vue')
const PurchasePage = () => import('@/views/purchase/PurchasePage.vue')
const ReceivablePage = () => import('@/views/finance/ReceivablePage.vue')
const ProfitPage = () => import('@/views/finance/ProfitPage.vue')
const CustomerList = () => import('@/views/customers/CustomerList.vue')
const CustomerDetail = () => import('@/views/customers/CustomerDetail.vue')
const AfterSalesPage = () => import('@/views/AfterSalesPage.vue')
const EmployeeStats = () => import('@/views/EmployeeStats.vue')
const MasterData = () => import('@/views/MasterData.vue')
const SystemSettings = () => import('@/views/SystemSettings.vue')

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/', redirect: '/dashboard' },
    {
      path: '/',
      component: AppLayout,
      children: [
        { path: 'dashboard', component: Dashboard },
        { path: 'orders/list', component: OrderList },
        { path: 'orders/create', component: OrderForm },
        { path: 'orders/detail/:id', component: OrderDetail, props: true },
        { path: 'quotes/auto', component: AutoQuote },
        { path: 'quotes/list', component: QuoteList },
        { path: 'quotes/detail/:id', component: QuoteDetail, props: true },
        { path: 'samples/list', component: SampleList },
        { path: 'samples/detail/:id', component: SampleDetail, props: true },
        { path: 'production/overview', component: ProductionOverview },
        { path: 'production/detail/:id', component: ProductionDetail, props: true },
        { path: 'workshop/:type', component: WorkshopPage, props: true },
        { path: 'qc', component: QcPage },
        { path: 'inventory', component: InventoryPage },
        { path: 'purchase', component: PurchasePage },
        { path: 'finance/receivable', component: ReceivablePage },
        { path: 'finance/profit', component: ProfitPage },
        { path: 'customers/list', component: CustomerList },
        { path: 'customers/detail/:id', component: CustomerDetail, props: true },
        { path: 'after-sales', component: AfterSalesPage },
        { path: 'employees', component: EmployeeStats },
        { path: 'master-data', component: MasterData },
        { path: 'settings', component: SystemSettings }
      ]
    }
  ]
})

export default router
